import React, { useState, useEffect, useRef } from 'react';
import './CircleList.css'; // Make sure to create this CSS file
import { createPortal } from 'react-dom';
const getOrCreatePopupRoot = () => {
  let popupRoot = document.getElementById('popup-root');
  if (!popupRoot) {
    popupRoot = document.createElement('div');
    popupRoot.id = 'popup-root';
    document.body.appendChild(popupRoot);
  }
  return popupRoot;
};

const CircleList = (props) => {
  const { items } = props;
  console.log(items);

  const [activeItem, setActiveItem] = useState(null);

  const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });
  const popupRef = useRef();

  const handleItemClick = (item, event) => {
    event.stopPropagation();

    const targetRect = event.currentTarget.getBoundingClientRect();

    const offsetX = 60; // pixels to the right of item
    const offsetY = 10; // pixels below item

    setPopupPosition({
      top: targetRect.top + window.scrollY + offsetY,
      left: targetRect.left + window.scrollX + offsetX,
    });

    setActiveItem(item === activeItem ? null : item);
  };

  const handleClosePopup = () => {
    setActiveItem(null); // Close popup
  };
  const [radius] = useState('290px'); // Start with a percentage-based radius with 20vw Fixed radius with 430px

  const isFirefox = () => {
    return /firefox/i.test(global.navigator.userAgent);
  };

  const isChrome = () => {
    return (
      /chrome|chromium|crios/i.test(global.navigator.userAgent) &&
      !/edge|edg/i.test(global.navigator.userAgent)
    );
  };

  return (
    <div className="circle-container">
      <div className="circle-background-1">
        <div className="circle-background-1-2">
          <div className="circle-background-1-3">
            <div className="circle-background-2">
              <div className="circle-background-3">
                <div className="circle-background-4">
                  <div className="circle-background-5">
                    <div className="circle-background-6"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* List of circle items */}
      <ul className="circle-list">
        {items.map((item, index) => (
          <li
            key={index}
            className="circle-item"
            style={{
              '--i': index,
              '--total': items.length,
              '--radius': radius, // Dynamically set the radius of the items
            }}
            title={item.title}
            onClick={(event) => handleItemClick(item, event)}
          >
            {/* Item content goes here */}
          </li>
        ))}
      </ul>
      {/* SVG for curved text around the circle */}
      <svg viewBox="0 0 1400 1400" className="circle-text-svg">
        <defs>
          <path
            id="circlePath"
            d="M 700, 700 m -550, 0 a 550,550 0 1,1 1100,0 a 550,550 0 1,1 -1100,0"
          />
          <path
            id="circlePathReversed"
            d="M 700, 700 m 550, 0 a 550,550 0 1,1 -1100,0 a 550,550 0 1,1 1100,0"
          />
          <path
            id="circlePath-1"
            d="M 700, 700 m -435, 0 a 435,435 0 1,1 870,0 a 435,435 0 1,1 -870,0"
          />
          <path
            id="circlePath-2"
            d="M 700, 700 m -320, 0 a 320,320 0 1,1 640,0 a 320,320 0 1,1 -640,0"
          />
          <path
            id="circlePath-3"
            d="M 700, 700 m -200, 0 a 200,200 0 1,1 400,0 a 200,200 0 1,1 -400,0"
          />
        </defs>

        {/* Text elements that follow the circle path */}
        <text className="direction-text" dy="-90">
          <textPath href="#circlePath" startOffset="50%">
            Fahrzeug- und Umsetzungskonzepte
          </textPath>
        </text>
        <text className="direction-text" dy="-90">
          <textPath href="#circlePath" startOffset="100%">
            AVF Datenräume und -Dienste
          </textPath>
        </text>
        <text className="direction-text" dy="-90">
          <textPath href="#circlePath" startOffset="0%">
            AVF Datenräume und -Dienste
          </textPath>
        </text>
        <text className="direction-text" dy="-90">
          <textPath href="#circlePath" startOffset="25%" text-anchor="middle">
            Digitale und reale Infrastruktur
          </textPath>
        </text>
        {isFirefox() && (
          <text className="direction-text" dy="90">
            <textPath
              href="#circlePathReversed"
              startOffset="75%"
              side="right"
              text-anchor="middle"
            >
              Entwicklung, Test und Simulation
            </textPath>
          </text>
        )}
        {isChrome() && (
          <text className="direction-text" dy="-90">
            <textPath
              href="#circlePath"
              startOffset="75%"
              side="right"
              text-anchor="middle"
            >
              Entwicklung, Test und Simulation
            </textPath>
          </text>
        )}
        <text className="direction-text-inner-text-1" dy="-90">
          <textPath href="#circlePath-1" startOffset="25%">
            Methoden und Blaupausen
          </textPath>
        </text>
        <text className="direction-text-inner-text-2" dy="-90">
          <textPath href="#circlePath-2" startOffset="25%">
            Ressourcen und Werkzeuge
          </textPath>
        </text>
        <text className="direction-text-inner-text-2" dy="-90">
          <textPath href="#circlePath-3" startOffset="25%">
            Anlagenangebot: statisch
          </textPath>
        </text>
        <text
          x="50%"
          y="50%"
          textAnchor="middle"
          dy=".3em"
          className="centered-text"
        >
          <tspan x="50%" dy="0em">
            Anlagenangebot:
          </tspan>
          <tspan x="50%" dy="1.2em">
            dynamisch
          </tspan>
        </text>
      </svg>

      {/* Popup for showing item title */}
      {activeItem &&
        createPortal(
          <div
            className="popup"
            style={{
              top: popupPosition.top,
              left: popupPosition.left,
              position: 'absolute',
            }}
            onClick={handleClosePopup}
          >
            <div className="popup-title">{activeItem.title}</div>
            <div className="popup-description">{activeItem.description}</div>
            <div className="popup-read-more">
              <a
                href={activeItem['@id']}
                rel="noopener noreferrer"
                onClick={handleClosePopup}
              >
                Read More &gt;
              </a>
            </div>
          </div>,
          getOrCreatePopupRoot(),
        )}
    </div>
  );
};

export default CircleList;
